import React, {useState} from "react";
import {useSite} from "../../context/SiteContext";
import {HERO_STEPS, HERO_VIDEO, PHOTO} from "../../data/siteData";
import {asset, GRAD, inkOn} from "../../utils";
import Icon from "../common/Icon";
import Bars from "../common/Bars";
import Wave from "../common/Wave";
import ImageSlot from "../common/ImageSlot";

const HeroSection = () => {
    const {go, openApp} = useSite();
    const [videoReady, setVideoReady] = useState(false);

    return (
        <section id="top" className="pb-hero">
            <div className="pb-hero-poster">
                <ImageSlot src={PHOTO.hero} alt="Paddler on flat Nordic water"/>
            </div>
            {HERO_VIDEO && (
                <video src={asset(HERO_VIDEO)} autoPlay muted loop playsInline preload="metadata"
                       onCanPlay={() => setVideoReady(true)} className="pb-hero-video"
                       style={{opacity: videoReady ? 1 : 0}}/>
            )}
            <div className="pb-hero-scrim"/>
            <div className="pb-hero-content">
                <div className="pb-hero-enter" style={{marginBottom: 'clamp(8px,2svh,20px)'}}>
                    <Bars w={26} h={5} gap={6}/>
                </div>
                <p className="pb-hero-pill pb-hero-enter" style={{animationDelay: '90ms'}}>
                    <Icon name="box" size={15}/>Self service canoe rental
                </p>
                <h1 className="pb-hero-title pb-hero-enter" style={{animationDelay: '170ms'}}>
                    Unlock the canoe,<br/>
                    <span className="pb-text-sun">paddle away, lock the canoe.</span>
                </h1>
                <p className="pb-hero-lead pb-hero-enter" style={{animationDelay: '250ms'}}>
                    A locked box of gear waiting at the water's edge. Book on your phone, scan the QR code on the box,
                    and the lake is yours for the next adventure.
                </p>
                <div className="pb-hero-steps pb-hero-enter" style={{animationDelay: '330ms'}}>
                    {HERO_STEPS.map(step => (
                        <div key={step.label} className="pb-hero-step">
                            <span style={{background: GRAD[step.color], color: inkOn(step.color)}}>
                                <Icon name={step.icon} size={18}/>
                            </span>
                            <span className="pb-hero-step-label">{step.label}</span>
                        </div>
                    ))}
                </div>
                <div className="pb-hero-actions pb-hero-enter" style={{animationDelay: '410ms'}}>
                    <button onClick={() => go('loc')} className="pb-btn-sunset">
                        <Icon name="pin" size={16}/>Find a box near you
                    </button>
                    <button onClick={openApp} className="pb-btn-glass">
                        <Icon name="play" size={15}/>Get the app
                    </button>
                </div>
            </div>
            <Wave fill="#eef4fb" height={104}/>
        </section>
    );
};

export default HeroSection;
